<template>
  <section class="content">
    <div class="container-fluid">
        <div class="row" v-if="$gate.isAllowed('is_laporan')">
          <div class="col-md-12">
            <div class="card">
                <div class="card-header">
                    <h3 class="card-title">Timeline Keuangan <small>(Bulan Juni 2022)</small></h3>
                    <div class="card-tools">
                        <!--button type="button" class="btn btn-sm btn-success" @click="false">
                            <i class="fa fa-check-square"></i>
                            &nbsp; PAID
                        </button>
                        <button type="button" class="btn btn-sm btn-danger" @click="false">
                            <i class="fa fa-credit-card"></i>
                            &nbsp; CREATE VA
                        </button>
                        <button type="button" class="btn btn-sm btn-warning" @click="false">
                            <i class="fa fa-print"></i>
                            &nbsp; Print Invoice
                        </button-->
                        <v-dialog
                            ref="dialog"
                            v-model="modaltgl"
                            :return-value.sync="tanggal_query"
                            persistent
                            width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field style="margin-top:0px;padding-top:0px"
                                v-model="tanggal_query"
                                label=""
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                            </template>
                            <v-date-picker
                            v-model="tanggal_query"
                            type="month"
                            scrollable
                            min="2022-05"
                            :max="dateMax"
                            
                            >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="primary"
                                @click="modaltgl = false"
                            >
                                Cancel
                            </v-btn>
                            <v-btn
                                text
                                color="primary"
                                @click="ubahTanggalTampil($refs)"
                            >
                                OK
                            </v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </div>
                </div>
                <v-app>
                    <v-content>
                        <div class="card-body ">
                            <div class="row">
                                <div class="col-md-12">
                                    
                                    <download-excel :data="datas"
                                    :fields="json_fields"
                                    :worksheet="getBulan(tanggal_query)"
                                    :name="'Laporan Keuangan '+ getBulan(tanggal_query) +'.xls'"
                                    >
                                        <button type="button" class="btn btn-sm btn-success">
                                            <i class="fa fa-file-excel"></i>
                                            &nbsp; Download
                                        </button>
                                    </download-excel>
                                    <!--button type="button" class="btn btn-sm btn-success" @click="false">
                                        <i class="fa fa-check-square"></i>
                                        &nbsp; PAID
                                    </button-->
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <v-timeline
                                        align-top
                                        :reverse="false"
                                        dense
                                    >
                                        <v-timeline-item
                                        v-for="data in datas"
                                        :key="data.id"
                                        :color=" data.kategori_tipe == '1' ? 'green lighten-1' : 'red lighten-2' "
                                        :icon=" data.kategori_tipe == '1' ? 'mdi-cash-plus' : 'mdi-cash-minus' "
                                        fill-dot
                                        >
                                        <v-card v-if="data.kategori_tipe == '1'"
                                            color='green lighten-1'
                                            dark
                                        >
                                            <v-card-title  >
                                                <v-row>
                                                     <v-col cols="8" v-if="data.kategori_id == '1'">
                                                        <router-link :to="'/laporan_riwayat?id='+data.inet_id">{{data.plg_nama}}</router-link> membayar Invoice {{data.jumlah | toCurrency}} ke <a href="javascript:void(0)">{{data.kantor_nama}}</a>
                                                    </v-col>
                                                    <v-col cols="8" v-else-if="data.kategori_id == '9'">
                                                        {{data.admin_nama}} Setting Saldo {{data.jumlah | toCurrency}} ke <a href="javascript:void(0)">{{data.kantor_nama}}</a>
                                                    </v-col>
                                                    <v-col cols="8" v-else>
                                                        <a href="javascript:void(0)">{{data.kantor_nama}}</a> Mendapatkan Pemasukan Sejumlah {{data.jumlah | toCurrency}}
                                                    </v-col>
                                                    <v-col
                                                        class="text-right"
                                                        cols="4"
                                                    >
                                                        <small>{{data.tanggal}}</small>
                                                    </v-col>
                                                </v-row>
                                            </v-card-title>
                                            <v-card-text class="white text--primary" style="padding-top:16px">
                                                <v-row>
                                                    <v-col cols="12">
                                                        Keterangan : {{data.keterangan}}
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col
                                                        class="text-right"
                                                        cols="12"
                                                    ><small>Total Saldo {{data.kantor_nama}} <strong>{{data.saldo | toCurrency}}</strong></small>
                                                    </v-col>
                                                </v-row>
                                            </v-card-text>
                                        </v-card>
                                        <v-card v-if="data.kategori_tipe == '2'"
                                            color='red lighten-2'
                                            dark
                                        >
                                            <v-card-title  >
                                                <v-row>
                                                    <v-col cols="8">
                                                        {{data.admin_nama}} Melakukan Pengeluaran {{data.jumlah | toCurrency}} dari <a href="javascript:void(0)">{{data.kantor_nama}}</a>
                                                    </v-col>
                                                    <v-col
                                                        class="text-right"
                                                        cols="4"
                                                    >
                                                        <small>{{data.tanggal}}</small>
                                                    </v-col>
                                                </v-row>
                                            </v-card-title>
                                            <v-card-text class="white text--primary" style="padding-top:16px">
                                                <v-row>
                                                    <v-col cols="12">
                                                        Keterangan : {{data.keterangan}}
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col
                                                        class="text-right"
                                                        cols="12"
                                                    ><small>Total Saldo {{data.kantor_nama}} <strong>{{data.saldo | toCurrency}}</strong></small>
                                                    </v-col>
                                                </v-row>
                                            </v-card-text>
                                        </v-card>
                                        </v-timeline-item>
                                    </v-timeline>
                                </div>
                            </div>
                            <!--div class="timeline">
                                <div class="time-label">
                                    <span class="bg-blue">22 Juli 2014</span>
                                </div>
                                <div>
                                    <i class="fas fa-plus bg-green"></i>
                                    <div class="timeline-item">
                                        <span class="time"><i class="fas fa-clock"></i> 22 Juli 2022, 10:25</span>
                                        <h3 class="timeline-header"><router-link to="/laporan_riwayat?id=60130052">Pelanggan</router-link> membayar Invoice Rp 10.000.000 ke <a href="javascript:void(0)">Kantor A</a></h3>

                                        <div class="timeline-body">
                                            Bulan Pemakaian Juni 2022. Seharga Rp 10.000.000 untuk paket 100MB-UPTO
                                        </div>
                                        <div class="timeline-footer text-right">
                                            <small class="">Total Saldo Kantor A <strong>Rp 10.000.000</strong></small>
                                        </div>
                                    </div>
                                </div>
                                <div class="time-label">
                                    <span class="bg-blue">11 Feb. 2014</span>
                                </div>
                                <div>
                                    <i class="fas fa-minus bg-red"></i>
                                    <div class="timeline-item">
                                        <span class="time"><i class="fas fa-clock"></i> 12:05</span>
                                        <h3 class="timeline-header">Support Team Melakukan Pengeluaran Rp 5.000.000 dari <a href="javascript:void(0)">Kantor A</a></h3>

                                        <div class="timeline-body">
                                            Bayar Gaji : Rp 3.000.000, bayar makan Rp. 2.000.000
                                        </div>
                                        <div class="timeline-footer ">
                                            <div class="row">
                                                <div class="col-6 ">
                                                    <small class="">Disetujui Oleh <strong>Admin</strong></small>
                                                </div>
                                                <div class="col-6 text-right" >
                                                    <small class="">Total Saldo Kantor A <strong>Rp 5.000.000</strong></small>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <i class="fas fa-minus bg-red"></i>
                                    <div class="timeline-item">
                                        <span class="time"><i class="fas fa-clock"></i> 12:05</span>
                                        <h3 class="timeline-header">Support Team Melakukan Pengeluaran Rp 5.000.000 dari <a href="javascript:void(0)">Kantor A</a></h3>

                                        <div class="timeline-body">
                                            Bayar Gaji : Rp 3.000.000, bayar makan Rp. 2.000.000
                                        </div>
                                        <div class="timeline-footer ">
                                            <div class="row">
                                                <div class="col-6 ">
                                                    <small class="">Disetujui Oleh <strong>Admin</strong></small>
                                                </div>
                                                <div class="col-6 text-right" >
                                                    <small class="">Total Saldo Kantor A <strong>Rp 0</strong></small>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <i class="fas fa-clock bg-gray"></i>
                                </div>
                            </div-->
                        </div>
                    </v-content>
                </v-app>
              <!-- /.card-body -->
              <div class="card-footer">
                  
              </div>
            </div>
            
          </div>
            
        </div>


        <div v-if="!$gate.isAllowed('is_laporan')">
            <not-found></not-found>
        </div>

        
    </div>
  </section>
</template>

<script>
    export default {
        data () {
            return {
                dateMax: new Date().toISOString().substr(0, 7),
                tanggal_query: new Date().toISOString().substr(0, 7),
                tanggal_tampil: '',
                sortDesc : true,
                datas : [],
                modaltgl: false,
                menu2: false,
                menu: false,
                json_fields: {
                    "TANGGAL": "tanggal",
                    "TIPE": "kategori_tipe_nama",
                    "NAMA KATEGORI": "kategori_nama",
                    "KAS KANTOR": "kantor_nama",
                    "JUMLAH": "jumlah",
                    "SALDO": "saldo",
                    "KETERANGAN": "keterangan",
                },
            }
        },
        methods: {
          ubahTanggalTampil(e) {
            e.dialog.save(this.tanggal_query);
            this.loadData();       
           // if (!/\d/.test(event.key) && event.key !== '.') return event.preventDefault();
          },
          tableGrouping(e) {
            if(e.length){
              this.table_group_state = true;
            }else{
              this.table_group_state = false;
            }
          },
          loadData(){
            let tahun = this.tanggal_query.substr(0, 4);
            let bulan = this.tanggal_query.substr(-2, 2);

            if(this.$gate.isAllowed("is_laporan")){
                axios.get("api/laporan/keuangan?tahun="+tahun+"&bulan="+bulan).then(({ data }) => (this.datas = data.data));
            }
            this.tanggal_tampil = this.getBulan(this.tanggal_query);
          },
          getBulan(tanggal){
            var tgltemp = new Date(tanggal);
            var tahun = tgltemp.getFullYear();
            var bulan = ["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"];
            
            return (bulan[tgltemp.getMonth()] + " " + tahun);
          },
        },
        mounted() {
            
        },
        created() {
            this.$Progress.start();
            this.loadData();
            this.$Progress.finish();
        }
    }
</script>
